<template>
  <div v-if="!vacancy"
       class="vacancy-item">
    Vacancy deleted
  </div>
  <div
    v-else-if="data && vacancy"
    class="vacancy-item"
    :class="classes"
    @click.prevent="onClick"
  >
    <div class="vacancy-item__col _main">
      <div class="vacancy-item__label  d-sm-none">
        <span>ID: {{ vacancy.ID }}</span></div>
      <div class="vacancy-item__name">
        <router-link-modified
          :to="{ name: 'vacancy', params: { vacancyId: (vacancy[1] || {}).slug } }"
        >
          {{ description }}
        </router-link-modified>
      </div>

      <AccountMyVacanciesItemSalary :vacancy="vacancy"
                                    class="vacancy-item__salary  d-none  d-sm-block"/>

      <!--      <div class="vacancy-item__features">-->
      <!--        {{ vacancy.features.join(' • ') }}-->
      <!--      </div>-->

      <div class="vacancy-item__location-row">
        <AccountMyVacanciesItemVacancyLocation :vacancy="vacancy"/>
        <div class="vacancy-item__viewed">
          <BaseSvg name="ico-see"/>
          {{ vacancy.views }}
        </div>
      </div>
    </div>

    <div class="vacancy-item__col _salary  d-sm-none">
      <div class="vacancy-item__label">{{ $tMyVacancy('Salary') }}</div>
      <AccountMyVacanciesItemSalary :vacancy="vacancy"
                                    class="vacancy-item__salary"/>
    </div>

    <div class="vacancy-item__col  _employer  d-sm-none">
      <a
        href="#"
        class="vacancy-item__employer"
      >
        <div class="vacancy-item__employer-logo">
          <BaseImage
            v-if="((vacancy.employer || {}).employerProfile || {}).company_logo"
            src-key="company_logo"
            webp-key="company_logo_webp"
            :data="(vacancy.employer || {}).employerProfile || {}"
          />

          <BaseSvg v-else name="ico-avatar"/>
        </div>

        <div class="vacancy-item__label">{{ $tMyVacancy('Employer') }}</div>
        <div class="vacancy-item__employer-name" v-if="((vacancy.employer || {}).employerProfile || {}).name">
          {{ ((vacancy.employer || {}).employerProfile || {}).name }}
        </div>
        <div class="vacancy-item__employer-name" v-else>{{ $tVacancy('No name') }}</div>
      </a>
    </div>

    <template v-if="forResponse">
      <div class="vacancy-item__col _updated">
        <div class="vacancy-item__label">{{ $tMyVacancy('Last update') }}</div>
        <div
          v-if="vacancy.updated_at"
          class="vacancy-item__date"
        >
          {{ new Date(vacancy.updated_at).toLocaleDateString() }}
        </div>
      </div>

      <div class="vacancy-item__col _places">
        <div class="vacancy-item__label">{{ $tMyVacancy('Places') }}</div>
        <div
          class="vacancy-item__places-val"
          :class="{ _null: !(vacancy[1] || {}).quantity }"
        >
          {{ (vacancy[1] || {}).quantity }}
        </div>
      </div>

      <div class="vacancy-item__col _response">
        <router-link-modified
          class="vacancy-item__btn-response base-btn base-btn--green base-btn--small"
          :to="{ name: 'vacancy', params: { vacancyId: (vacancy[1] || {}).slug } }"
        >
          <span>{{ $tMyVacancy('To respond') }}</span>
        </router-link-modified>
      </div>

      <button
        type="button"
        class="vacancy-item__del"
        @click="$emit('delete', data.waiting_list_id)"
      >
        <BaseSvg name="ico-close"/>
      </button>
    </template>

    <template v-else-if="!plainVacancy">
      <div class="vacancy-item__col _date">
        <div class="vacancy-item__label">{{ $tMyVacancy('Sent') }}</div>
        <div class="vacancy-item__date">{{ data.send_resume_date }}</div>
      </div>

      <div v-if="denied"
           class="vacancy-item__col _status _no-link">
        <!--        <div-->
        <!--             class="vacancy-item__status-wrap">-->
        <!--          <router-link-modified  :to="{-->
        <!--                                    name: 'account-new-resume',-->
        <!--                                    query: {-->
        <!--                                      openSection: 3,-->
        <!--                                      scrollToId: 'passports',-->
        <!--                                      'passport-error': 'true',-->
        <!--                                    }-->
        <!--                                  }"-->
        <!--                                 class="vacancy-item__status  _yellow">-->
        <!--            {{ $tMyVacancy('Reupload passport') }}-->
        <!--          </router-link-modified>-->
        <!--        </div>-->
        <div class="vacancy-item__status-wrap">
          <button v-if="data.status === STATUS_PASSPORT_REJECTED"
                  @click.prevent="openChatBotModal"
                  class="vacancy-item__status  _yellow">
            {{ $tMyVacancy('Reupload passport') }}
          </button>
          <button v-else-if="data.status === STATUS_PASSPORT_UNLOADED"
                  @click.prevent="openChatBotModal"
                  class="vacancy-item__status  _yellow">
            {{ $tMyVacancy('Upload passport') }}
          </button>
          <button v-else-if="data.status === STATUS_PASSPORT_UNLOADED_AND_REJECTED"
                  @click.prevent="openChatBotModal"
                  class="vacancy-item__status  _yellow">
            {{ $tMyVacancy('Upload ans Reupload passport') }}
          </button>
          <div v-else class="vacancy-item__status">
            {{ $tMyVacancy('Denied') }}
          </div>
          <div class="vacancy-item__cause select-dropdown">
            <button
              type="button"
              class="vacancy-item__cause-btn"
              @click.prevent="showCause = true">
              <span v-if="data.status === STATUS_PASSPORT_REJECTED">
                {{ $tMyVacancy('Details') }}
              </span>
              <span v-else-if="data.status === STATUS_PASSPORT_UNLOADED">
                {{ $tMyVacancy('Details') }}
              </span>
              <span v-else-if="data.status === STATUS_PASSPORT_UNLOADED_AND_REJECTED">
                {{ $tMyVacancy('Details') }}
              </span>
              <template v-else>
                <span class="d-none d-sm-inline">{{ $tMyVacancy('Cause') }}</span>
                <span class="d-sm-none">{{ $tMyVacancy('Rejection reason') }}</span>
              </template>
              <BaseSvg name="ico-arrow-down"/>
            </button>
            <transition name="dropdown">
              <div v-if="showCause"
                   v-click-out="() => showCause = false"
                   class="select-dropdown__dropdown">
                <button
                  type="button"
                  class="select-dropdown__close"
                  @click.prevent="showCause = false">
                  <BaseSvg
                    name="ico-close"
                    width=".8rem"
                    height=".8rem"/>
                </button>

                <div v-if="data.status === STATUS_PASSPORT_REJECTED"
                     class="select-dropdown__options">
                  <div class="select-dropdown__text text">
                    <p>{{ $tMyVacancy('passport_rejected_text') }}</p>
                  </div>
                  <a href="#"
                     @click.prevent="openChatBotModal">
                    {{ $tMyVacancy('Go to passport') }}
                  </a>
                </div>

                <div v-else-if="data.status === STATUS_PASSPORT_UNLOADED"
                     class="select-dropdown__options">
                  <div class="select-dropdown__text text">
                    <p>{{ $tMyVacancy('passport_unloaded_text') }}</p>
                  </div>
                  <a href="#"
                     @click.prevent="openChatBotModal">
                    {{ $tMyVacancy('Go to passport') }}
                  </a>
                </div>

                <div v-else-if="data.status === STATUS_PASSPORT_UNLOADED_AND_REJECTED"
                     class="select-dropdown__options">
                  <div class="select-dropdown__text text">
                    <p>{{ $tMyVacancy('passport_unloaded_and_rejected_text') }}</p>
                  </div>
                  <a href="#"
                     @click.prevent="openChatBotModal">
                    {{ $tMyVacancy('Go to passport') }}
                  </a>
                </div>

                <div v-else class="select-dropdown__options">
                  <template v-if="data.reject_reasons || data.reject_reasons_description">
                    <div v-if="data.reject_reasons"
                         class="select-dropdown__text text">
                      {{ data.reject_reasons.name }}
                    </div>
                    <div v-if="data.reject_reasons_description"
                         class="select-dropdown__text text">
                      {{ data.reject_reasons_description }}
                    </div>
                  </template>
                  <div v-else
                       class="select-dropdown__text text">
                    {{ $tMyVacancy('Unknown') }}
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>


      <div v-else-if="invited"
           class="vacancy-item__col  _invited">
        <div class="vacancy-item__over-label">{{ $tMyVacancy('You are offered a job') }}</div>

        <div class="vacancy-item__label"><span>{{ $tMyVacancy('Invite from') }} </span>
          <time>{{ data.invite_date }}</time>
        </div>
        <button @click.prevent="onAcceptInvite"
                class="vacancy-item__btn-accept-invite  base-btn  base-btn--green  d-sm-none">
          <span>{{ $tMyVacancy('Accept invite') }}</span>
          <BaseSvg name="ico-arrow-light"
                   class="d-none  d-sm-inline-flex"/>
          <BasePreloader v-if="pendingAcceptInvite"
                         class="_small"/>
        </button>
      </div>

      <div v-else
           class="vacancy-item__col _status">
        <div class="vacancy-item__status-wrap">
          <div class="vacancy-item__status-text">{{ $tMyVacancy('Waiting for a response') }} ...</div>
        </div>
      </div>

      <button v-if="invited"
              @click.prevent="onAcceptInvite"
              class="vacancy-item__btn-accept-invite  base-btn  base-btn--green  d-none  d-sm-inline-flex">
        <span>{{ $tMyVacancy('Accept invite') }}</span>
        <BaseSvg name="ico-arrow-light"
                 class="d-none  d-sm-inline-flex"/>
        <BasePreloader v-if="pendingAcceptInvite"
                       class="_small"/>
      </button>
    </template>


    <template v-if="isBookmarks">
      <div class="vacancy-item__col  _bookmarks">

        <AccountMyVacanciesItemMainActions :vacancy="vacancy"
                                           @bookmark="$emit('bookmark', $event)"
                                           @responded="$emit('responded', $event)"/>

      </div>
    </template>
  </div>
</template>

<script>
  import AccountMyVacanciesItemMainActions from './AccountMyVacanciesItemMainActions'
  import AccountMyVacanciesItemVacancyLocation from './AccountMyVacanciesItemVacancyLocation'
  import AccountMyVacanciesItemSalary from './AccountMyVacanciesItemSalary'

  const STATUS_PASSPORT_REJECTED = 'passport_rejected'
  const STATUS_PASSPORT_UNLOADED = 'passport_unloaded'
  const STATUS_PASSPORT_UNLOADED_AND_REJECTED = 'passport_unloaded_and_rejected'
  const STATUS_RESPONSE_INVITED = 'invited'

  export default {
    name: 'AccountMyVacanciesItem',
    components: {
      AccountMyVacanciesItemMainActions,
      AccountMyVacanciesItemVacancyLocation,
      AccountMyVacanciesItemSalary,
    },
    props: {
      data: {
        type: Object,
        required: true
      },
      forResponse: {
        type: Boolean
      },
      plainVacancy: {
        type: Boolean,
        default: false
      },
      isBookmarks: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        pendingAcceptInvite: false,
        showCause: false,
        STATUS_PASSPORT_REJECTED,
        STATUS_PASSPORT_UNLOADED,
        STATUS_PASSPORT_UNLOADED_AND_REJECTED,
      };
    },

    computed: {
      classes() {
        return {
          '_denied': this.denied,
          '_for-response': this.forResponse,
          '_disabled': this.disabled,
          '_invited': this.invited
        };
      },

      vacancy() {
        if (this.plainVacancy) {
          return this.data
        }

        return this.data.vacancy
      },

      denied() {
        return this.data.status === 'reject'
          || this.data.status === STATUS_PASSPORT_REJECTED
          || this.data.status === STATUS_PASSPORT_UNLOADED
          || this.data.status === STATUS_PASSPORT_UNLOADED_AND_REJECTED
      },

      invited() {
        return this.data.status === STATUS_RESPONSE_INVITED
      },

      disabled() {
        return this.forResponse && !(this.vacancy[1] || {}).quantity;
      },

      description() {
        if (!this.data) return '';
        return (this.vacancy[1] || {}).name;
      },

      salary() {
        const salary = (this.vacancy[1] || {}).salary_in_selected_currency;
        if (typeof salary === 'object') return `${salary[0]} - ${salary[1]}`;

        return salary;
      },

      salaryPerType() {
        return (((this.vacancy[1] || {}).salary_type || {}).name || '').toLowerCase();
      },

      currentCurrency() {
        return this.$store.state.currentCurrency.symbol;
      },

      icons() {
        const {
          conditions_observation_housing,
          conditions_observation_housing_type,
          conditions_housing,
          conditions_housing_type,
          conditions_housing_description,
          conditions_meals,
          conditions_meals_type,
          conditions_transport,
          conditions_transport_type,
          conditions_clothes,
          conditions_clothes_type,
        } = (this.vacancy[1] || {});

        return {
          observation: !!(conditions_observation_housing || conditions_observation_housing_type),
          housing: !!(conditions_housing || conditions_housing_type || conditions_housing_description),
          meals: !!(conditions_meals || conditions_meals_type),
          transport: !!(conditions_transport || conditions_transport_type),
          clothes: !!(conditions_clothes || conditions_clothes_type)
        };
      }
    },
    methods: {
      onClick(e) {
        if (e.target.closest('a, button, input, ._no-link')) return

        this.$router.push({
          name: 'vacancy', params: {
            vacancyId: this.vacancy[1].slug
          }
        })
      },
      onAcceptInvite() {
        this.$vModal.open('accept-invite', {
          resumeId: this.data.send_resume_id
        })
      },
      openChatBotModal() {
        this.$vModal.open('after-respond-without-resume', {
          vacancyId: this.vacancy.ID,
        })
      }
    }
  };
</script>
